/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsCustomProductImage,
    MelcoFusionModelsCustomProductImageFromJSON,
    MelcoFusionModelsCustomProductImageFromJSONTyped,
    MelcoFusionModelsCustomProductImageToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoFusionModelsCustomProductView
 */
export interface MelcoFusionModelsCustomProductView {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductView
     */
    name?: string | null;
    /**
     * 
     * @type {Array<MelcoFusionModelsCustomProductImage>}
     * @memberof MelcoFusionModelsCustomProductView
     */
    color_list?: Array<MelcoFusionModelsCustomProductImage> | null;
}

export function MelcoFusionModelsCustomProductViewFromJSON(json: any): MelcoFusionModelsCustomProductView {
    return MelcoFusionModelsCustomProductViewFromJSONTyped(json, false);
}

export function MelcoFusionModelsCustomProductViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsCustomProductView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'color_list': !exists(json, 'color_list') ? undefined : (json['color_list'] === null ? null : (json['color_list'] as Array<any>).map(MelcoFusionModelsCustomProductImageFromJSON)),
    };
}

export function MelcoFusionModelsCustomProductViewToJSON(value?: MelcoFusionModelsCustomProductView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'color_list': value.color_list === undefined ? undefined : (value.color_list === null ? null : (value.color_list as Array<any>).map(MelcoFusionModelsCustomProductImageToJSON)),
    };
}


